import { IconDots } from '@tabler/icons-react';
import UsersTable from '@/components/userTable/UsersTable';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import PageTitle from '@/components/titles/PageTitle';
import useOrganizationRoles from '@/hooks/useOrganizationRoles';
import useOrganization from '@/hooks/useOrganization';
import { RenameOrganizationModal, DeleteOrganizationModal } from '@/components/Modals';

function OrganizationalSettings() {
  const { isUserOwner } = useOrganizationRoles();
  const { organization } = useOrganization();
  const organizationName = organization?.name;
  const currentOrgName = organizationName ?? 'Untitled Organization';

  return (
    <main className="flex flex-col w-full h-full">
      <div className="flex items-center gap-2">
        <PageTitle title="organizationalSettings" />
        {isUserOwner && (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button type="button" variant="ghost" className="-translate-y-1">
                <IconDots size={17} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-52 z-100">
              <RenameOrganizationModal currentOrgName={currentOrgName} />
              <DeleteOrganizationModal currentOrgName={currentOrgName} />
            </DropdownMenuContent>
          </DropdownMenu>
        )}
      </div>
      {/* data table for users management */}
      <UsersTable />
    </main>
  );
}

export default OrganizationalSettings;
